import * as React from 'react';
import * as styles from './styles.css';

import { Button, LinkButton } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import whatsappIco from './whatsapp.svg';

export interface IAgentContactsProps {
  onOpenPhone(): void;
  isOpenPhone: boolean;
  isDesktop: boolean;
  formattedPhone: string;
  phone: string;
}

export const AgentContacts: React.FC<IAgentContactsProps> = ({
  onOpenPhone,
  formattedPhone,
  isOpenPhone,
  isDesktop,
  phone,
}) => {
  return (
    <div data-testid="AgentContacts" className={styles['container']}>
      <div className={styles['button']}>
        {isDesktop ? (
          <Button
            data-testid="onOpenPhoneBtn"
            theme="fill_primary"
            size="M"
            beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
            onClick={onOpenPhone}
            fullWidth
          >
            {isOpenPhone ? formattedPhone : 'Показать контакты'}
          </Button>
        ) : (
          <LinkButton
            href={`tel:${phone}`}
            theme="fill_primary"
            size="M"
            beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
            fullWidth
          >
            Позвонить
          </LinkButton>
        )}
      </div>
      <div className={styles['button']}>
        <LinkButton
          href={`https://wa.me/${phone.substr(1)}`}
          target="_blank"
          theme="fill_secondary"
          size="M"
          beforeIcon={<img src={whatsappIco} alt="whatsapp" />}
          fullWidth
        >
          Написать в WhatsApp
        </LinkButton>
      </div>
    </div>
  );
};

AgentContacts.displayName = 'AgentContacts';
